export const FAMILY_ID = 'familyId';
export const PRODUCT_ID = 'productId';
export const MINOR_VERSION = 'minorVersion';
export const VERSION = 'version';
